import { createFileRoute } from "@tanstack/react-router";
import FederalEmployeeDepressionTreatment from "@/pages/FederalEmployeeDepressionTreatment";
export const Route = createFileRoute("/federal-employee-depression-treatment")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Federal Employee Depression Treatment | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Federal employees with depression: TMS, SAINT TMS, SPRAVATO, and FEHB coverage options for treatment-resistant depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Federal Employee Depression Treatment | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Federal employees with depression: TMS, SAINT TMS, SPRAVATO, and FEHB coverage options for treatment-resistant depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/federal-employee-depression-treatment",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/federal-employee-depression-treatment",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FederalEmployeeDepressionTreatment />;
}
